module.exports = __webpack_public_path__ + "img/2.5266fc6d.svg";